module.exports = __webpack_public_path__ + "static/pic13-320fe6ee6e7678cd18bb2a2e7b059f01.png";